import React, { createContext, useContext, useMemo, useState } from "react";
import { axiosInstance } from "../../../Api/config";

const AuthContext = createContext(null);
const STORAGE_KEY = "kalikambal_admin_user";

const defaultAdmin = {
  name: "Admin",
  email: "admin@kalikambalmotors.com",
  role: "admin",
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    try {
      const storedUser = localStorage.getItem(STORAGE_KEY);
      return storedUser ? JSON.parse(storedUser) : null;
    } catch {
      return null;
    }
  });

  const login = async ({ email, password }) => {
    if (!email || !password) {
      return { ok: false, message: "Please enter email and password." };
    }

    try {
      const response = await axiosInstance.post("/login", {
        identifier: email,
        password: password,
      });

      if (response.data && response.data.success) {
        const adminUser = {
          name: response.data.user.name || "Admin",
          email: response.data.user.email,
          role: "admin",
          token: response.data.token,
        };
        localStorage.setItem(STORAGE_KEY, JSON.stringify(adminUser));
        setUser(adminUser);
        return { ok: true };
      } else {
        return { ok: false, message: response.data.error || "Login failed." };
      }
    } catch (err) {
      console.error("Login error:", err);
      const msg = err.response?.data?.error || "Invalid credentials or database connection failed.";
      return { ok: false, message: msg };
    }
  };

  const logout = () => {
    localStorage.removeItem(STORAGE_KEY);
    setUser(null);
  };

  const value = useMemo(
    () => ({
      user,
      isAuthenticated: Boolean(user),
      login,
      logout,
    }),
    [user]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used inside AuthProvider");
  }

  return context;
};
